import Box from "@mui/material/Box";
import Hidden from "@mui/material/Hidden";
import NotesList from "../edit-profile/notes";

export default function NotesPage() {
  return (
    <>
      <Hidden mdUp>
        <Box sx={{ height: "50px" }} />
      </Hidden>
      <Box sx={{ margin: "20px" }}>
        <NotesList />
      </Box>
    </>
  );
}
